import { render, staticRenderFns } from "./EmployeeCourseContentAdmin.vue?vue&type=template&id=472245c4&scoped=true"
import script from "./EmployeeCourseContentAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeCourseContentAdmin.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCourseContentAdmin.vue?vue&type=style&index=0&id=472245c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472245c4",
  null
  
)

export default component.exports